import { gql } from '@apollo/client';

export const FETCH_IDS = gql`
  query fetchUserIdVerifications($input: FetchUserIdVerificationsInput!) {
    fetchUserIdVerifications(input: $input) {
      idVerifications {
        id
        documentExpiryDate
        documentID
        documentIssuingJurisdication
        documentType
        methodOfIDVerification
        verifiedDate
        userName
        secondaryDocumentExpiryDate
        secondaryDocumentID
        secondaryDocumentIssuingJurisdication
        secondaryDocumentType
        secondaryDocumentUserName
      }
      totalCount
    }
  }
`;
export const UPDATE_USER_ID = gql`
  mutation updateUserIDVerificationInformation(
    $input: UpdateUserIDVerificationInformationInput!
  ) {
    updateUserIDVerificationInformation(input: $input) {
      idVerification {
        id
        documentExpiryDate
        documentID
        documentIssuingJurisdication
        documentType
        methodOfIDVerification
        verifiedDate
        userName
      }
    }
  }
`;
